export { getCurrentEnv, isBrowserEnv, isNodeEnv } from './env-check';
